import { useEffect, useState } from 'react';
import { ArrowLeft, Bell, BellOff, Shield } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';

export default function Header({ showBack = false, backLabel = '', onBack, rightAction = null }) {
  const { isAuthenticated } = useAuth();

  return (
    <header className="relative h-14 bg-white border-b border-gray-100 flex items-center justify-between px-5 rounded-b-3xl shadow-sm md:h-16 z-50">
      {showBack ? (
        <button
          type="button"
          onClick={onBack}
          className="min-h-11 flex items-center gap-3 text-text-primary active:scale-95 transition-transform"
          aria-label="Retour"
        >
          <ArrowLeft className="w-6 h-6 text-brand-navy" strokeWidth={2.5} />
          <span className="font-bold text-xl text-brand-navy leading-none">{backLabel}</span>
        </button>
      ) : (
        <div className="flex items-center gap-3 min-w-0">
          <Shield className="w-6 h-6 text-brand-navy flex-shrink-0" strokeWidth={2.3} />
          <span className="font-bold text-lg md:text-xl text-brand-navy tracking-wide whitespace-nowrap flex-shrink-0">SENTINELLE</span>
        </div>
      )}

      {rightAction || (isAuthenticated ? <NotificationButton /> : <div className="w-10" aria-hidden="true" />)}
    </header>
  );
}

function NotificationButton() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [open]);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className={`relative w-11 h-11 rounded-full border flex items-center justify-center shadow-sm active:scale-95 transition-all ${open ? 'bg-brand-navy text-white border-brand-navy' : 'bg-brand-navy-light text-brand-navy border-brand-navy/10'}`}
        aria-label="Voir les notifications"
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        <Bell className="w-5 h-5" strokeWidth={2.4} />
      </button>

      {open ? (
        <div className="absolute right-0 top-14 w-[280px] rounded-2xl bg-white border border-gray-100 shadow-2xl shadow-gray-900/10 p-4" role="dialog" aria-label="Notifications">
          <div className="flex items-center justify-between gap-3 border-b border-gray-100 pb-3">
            <div>
              <p className="font-bold text-brand-navy">Notifications</p>
              <p className="text-xs text-text-muted">Votre activité SENTINELLE</p>
            </div>
            <button type="button" onClick={() => setOpen(false)} className="min-h-11 px-3 text-sm font-semibold text-accent-blue active:scale-95 transition-transform" aria-label="Fermer les notifications">Fermer</button>
          </div>

          <div className="py-8 text-center">
            <div className="mx-auto w-14 h-14 rounded-2xl bg-gray-100 text-text-muted flex items-center justify-center">
              <BellOff className="w-7 h-7" />
            </div>
            <p className="mt-4 font-bold text-text-primary">Aucune notification</p>
            <p className="mt-2 text-sm text-text-muted leading-relaxed">Vous serez prévenu ici lorsqu'une analyse, un rapport ou un signalement demandera votre attention.</p>
          </div>
        </div>
      ) : null}
    </div>
  );
}